import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import '../../../Core/Dashbord/mainDashboard.scss';
import PartReqCommon from '../../../Core/Dashbord/BaseComp/PartReq';
import Inspections from '../../../Core/Dashbord/BaseComp/Inspections';
import { EWIPDates } from '../../../Core/Dashbord/BaseComp/wip-date';
import WipDashboardBranch from '../../../Core/Dashbord/BaseComp/wipDash-Branch';
import { WipDashboardTechnician } from '../../../Core/Dashbord/BaseComp/wipDash-Technician';
import '../../../Core/Dashbord/BaseComp/wipStyles.scss';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        margin: 3,
        border: 'none',
        opacity: 0.9,
        minWidth: 120,
        padding: '5px 0px',
        background: 'white',
        borderRadius: 5
    }
}));

const TechnicianDashboardCharts = (props) => {
    const { state } = props;
    const classes = useStyles();
    const history = useHistory();
    const [array, setArray] = useState({
        byTimeObj: {
            lessThan24HoursOld: 0,
            between1And5DaysOld: 0,
            between5And10DaysOld: 0,
            between10And20DaysOld: 0,
            between21And30DaysOld: 0,
            over30DaysOld: 0,
            preBooking: 0,
            between1to10Days: 0,
            between11And20Days: 0,
            between21And30Days: 0,
            overdueOver30DaysOld: 0,
            overdueArchived: 0,
            bn: ''
        },
        showLoader: true,
        assignedDate: 2,
        assignedJobs: [],
        selectedPieChartType: 'A',
        byAssignedUser: 'Default',
        assignedJobsTotals: 0,
        byTimeBranch: 'Default',
        selectedValueByTech: 'Default',
        selectedFilterTechData: [],
        techJobsTotal: 0
    });

    const findByTimeValues = (val) => {
        let indexObj = {
            lessThan24HoursOld: 0,
            between1And5DaysOld: 0,
            between5And10DaysOld: 0,
            between10And20DaysOld: 0,
            between21And30DaysOld: 0,
            over30DaysOld: 0,
            preBooking: 0,
            between1to10Days: 0,
            between11And20Days: 0,
            between21And30Days: 0,
            overdueOver30DaysOld: 0,
            overdueArchived: 0,
            bn: ''
        };

        if (val === 'Default') {
            if (state?.sumOFByTimeForALL && state.sumOFByTimeForALL.length > 0) {
                let letNewData = state.sumOFByTimeForALL.reduce((acc, obj) => {
                    var index = acc.find((item) => item);
                    if (index) {
                        index.lessThan24HoursOld += obj?.lessThan24HoursOld || 0;
                        index.between1And5DaysOld += obj?.between1And5DaysOld || 0;
                        index.between5And10DaysOld += obj?.between5And10DaysOld || 0;
                        index.between10And20DaysOld += obj?.between10And20DaysOld || 0;
                        index.between21And30DaysOld += obj?.between21And30DaysOld || 0;
                        index.over30DaysOld += obj?.over30DaysOld || 0;
                        index.preBooking += obj?.preBooking || 0;
                        index.between1to10Days += obj?.between1to10Days || 0;
                        index.between11And20Days += obj?.between11And20Days || 0;
                        index.between21And30Days += obj?.between21And30Days || 0;
                        index.overdueOver30DaysOld += obj?.overdueOver30DaysOld || 0;
                        index.overdueArchived += obj?.overdueArchived || 0;
                        return acc;
                    }
                    acc.push({ ...obj });
                    return acc;
                }, []);
                let found = letNewData?.find((item) => item);
                if (found) {
                    indexObj = { ...found, bn: '' };
                }
            }
            setArray((st) => ({ ...st, byTimeObj: indexObj, byTimeBranch: val }));
        } else {
            let found = state?.sumOFByTimeForALL?.find((n) => n.bn === val);
            if (found) {
                indexObj = { ...found };
            }
            setArray((st) => ({ ...st, byTimeObj: indexObj, byTimeBranch: val }));
        }
    };

    useEffect(() => {
        let btTimeData = JSON.parse(localStorage.getItem('FiltterParams'));
        if (btTimeData?.branchShortName) {
            props.getbranchByOnchange && props.getbranchByOnchange(btTimeData?.branchShortName);
            findByTimeValues(btTimeData.branchShortName);
        } else {
            props.getbranchByOnchange && props.getbranchByOnchange('Default');
            findByTimeValues('Default');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let btTimeData = JSON.parse(localStorage.getItem('FiltterParams'));
        findByTimeValues(btTimeData?.branchShortName || 'Default');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state?.sumOFByTimeForALL]);

    useEffect(() => {
        if (state?.assignedJobs && state.assignedJobs.length > 0) {
            let isJobAssigned = state.assignedJobs.filter((k) => k.userID === array.byAssignedUser);
            let allTotal = 0;
            if (state.assignedJobs.length > 0 && (array.byAssignedUser === 'Default' || isJobAssigned.length === 0)) {
                const allAssignedJobsData = state.assignedJobs.reduce((acc, obj) => {
                    allTotal += obj.total || 0;
                    const index = acc.find((item) => item.workflowID === obj.workflowID);
                    index ? (index.total += obj.total || 0) : acc.push({ ...obj });
                    return acc;
                }, []);

                setArray((st) => ({ ...st, assignedJobs: allAssignedJobsData, assignedJobsTotals: allTotal }));
            } else {
                const allAssignedJobsData = state.assignedJobs
                    .filter((item) => {
                        if (item.userID === array.byAssignedUser) {
                            allTotal += item.total || 0;
                            return item;
                        }
                        return null;
                    })
                    .filter(Boolean);
                setArray((st) => ({ ...st, assignedJobs: allAssignedJobsData, assignedJobsTotals: allTotal }));
            }
        } else {
            setArray((st) => ({ ...st, assignedJobs: [], assignedJobsTotals: 0 }));
        }
    }, [state?.assignedJobs, array.byAssignedUser]);

    useEffect(() => {
        let branch = props.selectedBranch || 'Default';
        pullTechnicianJobsData(branch);
        findByTimeValues(branch);
        setArray((st) => ({
            ...st,
            byTimeBranch: branch,
            selectedValueByTech: branch
        }));
    }, [props.selectedBranch, state?.technicianJobsData, state?.sumOFByTimeForALL]);

    const pullTechnicianJobsData = (val) => {
        let tempLocalData = JSON.parse(localStorage.getItem('_dashboard_')) || {};
        if (val && val !== 'Default') {
            let tempData = (state?.technicianJobsData || []).find((m) => m.bn === val) || [];
            let techJobsTotal = 0;
            if (tempData?.length > 0) {
                tempData.forEach((q) => {
                    techJobsTotal += q.total || 0;
                });
            }
            setArray((st) => ({
                ...st,
                selectedValueByTech: val,
                selectedFilterTechData: tempData,
                techJobsTotal: techJobsTotal
            }));
            localStorage.setItem('_dashboard_', JSON.stringify({ ...tempLocalData, selectedValueByTech: val, BranchBytime: val }));
        } else {
            let allTechData = (state?.technicianJobsData || []).flat();
            let techJobsTotal = 0;
            if (allTechData?.length > 0) {
                allTechData.forEach((q) => {
                    techJobsTotal += q.total || 0;
                });
            }
            setArray((st) => ({
                ...st,
                selectedValueByTech: 'Default',
                selectedFilterTechData: allTechData,
                techJobsTotal: techJobsTotal
            }));
            localStorage.setItem('_dashboard_', JSON.stringify({ ...tempLocalData, selectedValueByTech: 'Default' }));
        }
    };

    useEffect(() => {
        let tempData = JSON.parse(localStorage.getItem('_dashboard_')) || {};
        if (state?.technicianJobsData && state.technicianJobsData.length > 0) {
            let targetBranch = tempData?.selectedValueByTech;
            if (!targetBranch || targetBranch === 'Default' || !state.technicianJobsData.some((m) => m.bn === targetBranch)) {
                targetBranch = state.technicianJobsData[0]?.bn || state?.chartdata?.[0]?.name;
            }
            if (targetBranch) {
                pullTechnicianJobsData(targetBranch);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state?.technicianJobsData, state?.chartdata]);

    const handleChangeByTime = (e) => {
        let tempData = JSON.parse(localStorage.getItem('_dashboard_')) || {};
        let valueByTime = e.target.value;
        pullTechnicianJobsData(valueByTime);
        props.getbranchByOnchange && props.getbranchByOnchange(valueByTime);
        findByTimeValues(valueByTime);
        props.getPartReq && props.getPartReq(valueByTime);
        localStorage.setItem(
            'FiltterParams',
            JSON.stringify({
                branchShortName: valueByTime !== 'Default' ? valueByTime : ''
            })
        );
        if (valueByTime !== 'Default') {
            localStorage.setItem(
                '_dashboard_',
                JSON.stringify({
                    ...tempData,
                    BranchBytime: valueByTime,
                    selectedValueByTech: valueByTime,
                    BranchPartReq: valueByTime
                })
            );
        } else {
            localStorage.setItem(
                '_dashboard_',
                JSON.stringify({
                    ...tempData,
                    BranchPartReq: valueByTime
                })
            );
        }
    };

    const handleDate = (val) => {
        if (val?._reactName === 'onChange') {
            setArray((st) => ({ ...st, assignedDate: val.target.value }));
        } else {
            setArray((st) => ({ ...st, assignedDate: val }));
        }
    };

    const handlePieCard = (val) => {
        setArray((st) => ({ ...st, selectedPieChartType: val }));
    };

    const handleChangeAssignedUser = (e) => {
        setArray((st) => ({
            ...st,
            byAssignedUser: e.target.value
        }));
    };

    const handlePartReq = (techObj) => {
        let searchQuery = `?id=${techObj.id}&bn=${techObj.bn}`;
        history.push({
            pathname: '/RenaultPartReqs/PartReqs_By_Status',
            search: searchQuery
        });
    };

    const handleReturn = (techObj) => {
        let searchQuery = `?id=${techObj.statusID}`;
        history.push({
            pathname: `/Renault/PartReturn`,
            search: searchQuery
        });
    };

    const handleTechOnClick = (techObj) => {
        localStorage.setItem('FiltterParams', JSON.stringify({ branchShortName: techObj.bn }));
        let searchQuery = `&tid=${techObj.tid || ''}&bnm=${techObj.bn}&tnm=${techObj.name}&bid=${techObj.bid}`;
        history.push({
            pathname: '/techDashgrid',
            search: searchQuery,
            state: {}
        });
    };

    const handleTechCalender = (techObj) => {
        localStorage.setItem('FiltterParams', JSON.stringify({ branchShortName: techObj.bn }));
        let searchQuery = `&tid=${techObj.tid || ''}&bnm=${techObj.bn}&tnm=${techObj.name}&bid=${techObj.bid}`;
        history.push({
            pathname: '/TechnicianCalender',
            search: searchQuery,
            state: {}
        });
    };

    const redirectToAssignedJobs = (val) => {
        const btnName = (val?.workflow || val?.name || '').toLowerCase().trim();
        const isAssignedToYou = btnName.includes('assigned to you') || val?.workflowID === 1 || val?.id === 1;
        const isAssignedToOthers = btnName.includes('assigned to others') || val?.workflowID === 3 || val?.id === 3;

        let bucketId = null;
        let workflowName = val?.workflow || val?.name || '';

        if (isAssignedToOthers) {
            bucketId = 3;
        } else if (isAssignedToYou) {
            bucketId = 1;
        } else if (val?.workflowID && val?.workflowID !== 'All') {
            bucketId = val.workflowID;
        } else if (val?.id) {
            bucketId = val.id;
        }

        history.push({
            pathname: '/technicianApp',
            search: bucketId ? `?bucketId=${bucketId}&name=${encodeURIComponent(workflowName)}` : `?name=${encodeURIComponent(workflowName)}`,
            state: { bucketId: bucketId, workflowName: workflowName, workflowID: val?.workflowID }
        });
    };

    const DateObj = [
        {
            assignedDateObj: [
                { time: 1, label: 'Less Than 24Hr', BarColor: '6px solid #00F433', value: array.byTimeObj?.lessThan24HoursOld || 0 },
                { time: 2, label: '1 to 5 Days', BarColor: '6px solid #88EBA4', value: array.byTimeObj?.between1And5DaysOld || 0 },
                { time: 3, label: '5 to 10 Days', BarColor: '6px solid #FFBF00', value: array.byTimeObj?.between5And10DaysOld || 0 },
                { time: 4, label: '10 to 20 Days', BarColor: '6px solid #FFE28A', value: array.byTimeObj?.between10And20DaysOld || 0 },
                { time: 5, label: '20 to 30 Days', BarColor: '6px solid #bc4443', value: array.byTimeObj?.between21And30DaysOld || 0 },
                { time: 6, label: 'Over 30 Days', BarColor: '6px solid #F11C0E', value: array.byTimeObj?.over30DaysOld || 0 }
            ],
            OverDateObj: [
                { dueTime: 1, label: 'Pre Booking', BarColor: '6px solid #88EBA4', value: array.byTimeObj?.preBooking || 0 },
                { dueTime: 2, label: '1 to 10 Days', BarColor: '6px solid #FFBF00', value: array.byTimeObj?.between1to10Days || 0 },
                { dueTime: 3, label: '10 to 20 Days', BarColor: '6px solid #FFE28A', value: array.byTimeObj?.between11And20Days || 0 },
                { dueTime: 4, label: '20 to 30 Days', BarColor: '6px solid #bc4443', value: array.byTimeObj?.between21And30Days || 0 },
                { dueTime: 5, label: 'Over 30 Days', BarColor: '6px solid #F11C0E', value: array.byTimeObj?.overdueOver30DaysOld || 0 },
                { dueTime: -1, label: 'Archived', BarColor: '6px solid #F11C0E', value: array.byTimeObj?.overdueArchived || 0 }
            ]
        }
    ];

    const WipsDate = [
        { id: 2, name: 'Overdue WIPs' },
        { id: 1, name: 'Assigned Date' }
    ];

    let Returns = props?.parts?.returnList || [];
    let partReqObj = props?.parts?.partReqList || [];
    let getDateObj = array.assignedDate === 1 ? DateObj[0].assignedDateObj : DateObj[0].OverDateObj;

    return (
        <Grid container spacing={2}>
            {/* Jobs By Technicians */}
            <Grid item xs={12}>
                <WipDashboardTechnician
                    state={state}
                    array={array}
                    handleTechCalender={handleTechCalender}
                    classes={classes}
                    handleTechOnClick={handleTechOnClick}
                    handleChangeByTime={handleChangeByTime}
                    fromTechnicianDashboard={true}
                />
            </Grid>

            {/* Inspections */}
            <Grid item xs={12}>
                <Inspections
                    state={state}
                    header={'Inspections'}
                    selectedBranch={props.selectedBranch || array.byTimeBranch || state.selectedBranch}
                    handleChangeByBranch={handleChangeByTime}
                />
            </Grid>

            {/* Part Requisitions */}
            <Grid item xs={12}>
                <PartReqCommon
                    header={'Part Requisitions'}
                    state={state}
                    array={array}
                    classes={classes}
                    List={partReqObj}
                    handleClick={handlePartReq}
                    handleChangeByPartsReq={handleChangeByTime}
                />
            </Grid>
            {/* Returns */}
            <Grid item xs={12}>
                <PartReqCommon
                    header={'Returns'}
                    state={state}
                    array={array}
                    classes={classes}
                    handleChangeByPartsReq={handleChangeByTime}
                    List={Returns}
                    handleClick={handleReturn}
                />
            </Grid>
        </Grid>
    );
};

export default TechnicianDashboardCharts;
